import * as React from "react";

import { Row, Column } from "@ui/Atoms/Grid";
import { SkeletonGenerator } from "@ui/Atoms";

const BasicInfoSkeleton = React.memo(() => (
  <React.Fragment>
    {[0, 1, 2].map(idx => (
      <Row key={idx}>
        <Column xs={12} md={6}>
          <SkeletonGenerator count={1} />
        </Column>
        <Column xs={12} md={6}>
          <SkeletonGenerator count={1} />
        </Column>
      </Row>
    ))}
    <Row>
      <Column md={3} pushMd={9}>
        <SkeletonGenerator count={1} />
      </Column>
    </Row>
  </React.Fragment>
));

BasicInfoSkeleton.displayName = "BasicInfoSkeleton";

const ContractDetailsPageSkeleton = React.memo(() => (
  <React.Fragment>
    <SkeletonGenerator
      count={1}
      shape="rectVertical"
      noGutter
      randomHeight={140}
    />
    <SkeletonGenerator
      count={1}
      shape="rectVertical"
      noGutter
      randomHeight={140}
    />
    <SkeletonGenerator count={1} shape="rectVertical" randomHeight={140} />

    <SkeletonGenerator count={4} shape="rectVertical" randomHeight={160} />
  </React.Fragment>
));

ContractDetailsPageSkeleton.displayName = "ContractDetailsPageSkeleton";

export { BasicInfoSkeleton, ContractDetailsPageSkeleton };
